<template>
  <div class="tab-pane" v-show="show || width < 1200" :id="$attrs.id + '-content'">
    <slot></slot>
  </div>
</template>
<script>
import { inject, toRefs } from 'vue'
import { useWindowSize } from '@vueuse/core'

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    active: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props, { attrs }) {
    const { width } = useWindowSize()

    const addTab = inject('addTab')
    const tab = addTab(props.title, props.active, attrs?.id)

    return {
      ...toRefs(tab),
      width,
    }
  },
}
</script>
